<div
  class="flex flex-col items-center justify-center min-h-screen bg-gray-100 p-6 space-y-8"
  >
  <button
    (click)="createStoredAddresses()"
    class="bg-blue-600 hover:bg-blue-700 text-white font-semibold px-8 py-4 rounded-lg shadow-lg transition transform hover:scale-105 active:scale-95 focus:outline-none focus:ring-4 focus:ring-blue-300"
    >
    Create Stored Addresses
  </button>

  <div
    class="w-full max-w-xl h-48 bg-black bg-opacity-90 text-green-400 font-mono text-sm rounded-lg p-4 overflow-y-auto shadow-inner"
    >
    @for (logEntry of logs; track logEntry) {
      <div>{{ logEntry }}</div>
    }
  </div>
</div>
